import { AfterViewInit, Directive, ElementRef } from '@angular/core';

declare var jQuery: any;

@Directive({
    selector: '[appInitializeDropdown]',
    standalone: false
})
export class InitializeDropdownDirective implements AfterViewInit {

  constructor(private readonly element: ElementRef) { }

  ngAfterViewInit(): void {
    jQuery(this.element.nativeElement).dropdown();
  }
}
